<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="actionLoading"
        >
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isEditable && showOnly">
                        Zestaw - <strong>{{ distributionCenterSetData.productSet.name }}</strong>
                    </template>
                    <template v-else>
                        <template v-if="isNewSet">
                            Dodaj zestaw
                        </template>
                        <template v-else>
                            Edycja zestawu - <strong>{{ distributionCenterSetData.productSet.name }}</strong>
                        </template>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="distributionCenterSetModel.productSet"
                                :items="availableSets"
                                label="Zestaw"
                                return-object
                                outlined
                                dense
                                item-text="name"
                                item-value="id"
                                :readonly="!isNewSet"
                                :error-messages="distributionCenterSetErrors"
                                @change="setChanged"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="distributionCenterSetModel.amount"
                                :error-messages="distributionCenterSetAmountErrors"
                                label="Ilość"
                                outlined
                                dense
                                persistent-hint
                                required
                                @input="$v.distributionCenterSetModel.amount.$touch()"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    :disabled="isInvalid"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'

export default {
    name: 'CampaignDistributionCenterSetDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        isEditable: {
            type: Boolean
        },
        distributionCenterSetData: {
            type: Object,
            default: null
        },
        setList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            distributionCenterSetModel: {
                id: null,
                amount: null,
                productSet: null,
                productSetId: null,
            },
            actionLoading: false,
        }
    },
    validations() {
        let rules = {
            distributionCenterSetModel: {
                productSet: {
                    required,
                },
                amount: {
                    required,
                    integer,
                    minValue: minValue(1),
                },
            },
        }

        return rules
    },
    computed: {
        isNewSet() {
            return isEmpty(this.distributionCenterSetData)
        },
        availableSets() {
            if (this.isNewSet) {
                return this.setList
            }

            return [ this.distributionCenterSetModel.productSet ]
        },
        distributionCenterSetErrors() {
            const errors = []

            if (!this.$v.distributionCenterSetModel.productSet.$dirty) return errors
            !this.$v.distributionCenterSetModel.productSet.required && errors.push('Proszę podać nazwę zestawu.')

            return errors
        },
        distributionCenterSetAmountErrors() {
            const errors = []

            if (!this.$v.distributionCenterSetModel.amount.$dirty) return errors
            !this.$v.distributionCenterSetModel.amount.required && errors.push('Proszę podać ilość zestawu.')

            if (!this.$v.distributionCenterSetModel.amount.minValue || !this.$v.distributionCenterSetModel.amount.integer) {
                errors.push('Proszę podać całkowitą dodatnią liczbę zestawów.')
            }

            return errors
        },
        isInvalid() {
            return this.$v.$invalid
        }
    },
    watch: {
        distributionCenterSetData(value) {
            if (!isEmpty(value)) {
                this.distributionCenterSetModel = {
                    id: value.id,
                    productSet: value.productSet,
                    productSetId: value.productSetId,
                    amount: value.amount,
                }
                this.$v.$touch()
            }
        }
    },
    methods: {
        setChanged() {
            this.distributionCenterSetModel.productSetId = this.distributionCenterSetModel.productSet.id
        },
        onSave() {
            this.distributionCenterSetModel.amount = parseInt(this.distributionCenterSetModel.amount)
            this.$emit('on-save', this.distributionCenterSetModel)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.actionLoading = false
                this.setInitialData()
            }, 500)

            this.$emit('on-close')
        },
        setInitialData() {
            this.distributionCenterSetModel = {
                id: null,
                productSet: null,
                productSetId: null,
                amount: null,
            }
            this.$v.$reset()
        }
    }
}
</script>
